let form = {
    init() {
        $('input').focusin(function() {
            $(this).parent().addClass('focus');
        });

        $('input').focusout(function() {
            $(this).parent().removeClass('focus');
        });

        form.floatingLabel();

        $('.form-wrapper .form-item select').change(function() {
            setTimeout(function(){
                form.floatingLabel();
            }, 300);
        });

        $('.form-wrapper .form-item input').change(function() {
            form.floatingLabel();
        });
    },
    floatingLabel() {
        $('.form-wrapper .form-item input, .form-wrapper .form-item select').each(function(){
            if( $(this).val().length > 0 ) {
                $(this).parent().addClass('active');
            }
        })
    }
}

export default form;
